export default {
  'ACCOMMODATION' (state) {
    return state.accommodation
  },
  'ACCOMMODATIONS' (state) {
    return state.accommodations
  }
}
